export default __webpack_public_path__ + "static/media/sunset-pb.771e171f.jpg";